/* eslint-disable no-console */
const name = `%c External Shell `;
const style = `background: #0a6; color: #fff; border-radius: 15px; padding: 2px;`;

export const DEBUG_KEY = 'external-shell-debug';
export const isDebugActive =
	localStorage.getItem(DEBUG_KEY) === 'true' || false;

export const debugLog = (...args: Array<unknown>) => {
	if (isDebugActive) console.log(name, style, ...args);
};

export const debugWarn = (...args: Array<unknown>) => {
	if (isDebugActive) console.warn(name, style, ...args);
};

export const debugError = (...args: Array<unknown>) => {
	if (isDebugActive) console.error(name, style, ...args);
};
